
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import ArticleAuthorList from '@root/modules/article/components/authors/ArticleAuthorList.vue';
import ArticleInfoSources from '@root/modules/article/components/info/ArticleInfoSources.vue';
import ArticleInfoSocial from '@root/modules/article/components/info/ArticleInfoSocial.vue';
import ArticleInfoPaywallDisableCoundown from '@root/modules/article/components/info/ArticleInfoPaywallDisableCountdown.vue';
import getArticleSources from '@root/modules/article/utils/getArticleSources';

interface Props {
  article: ArticleData;
  size: string;
}

interface Methods {
  handleSetFontSize: () => void;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  components: {
    ArticleAuthorList,
    ArticleInfoSources,
    ArticleInfoSocial,
    ArticleInfoPaywallDisableCoundown,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
  computed: {
    sources() {
      return getArticleSources(this.article);
    },
  },
  methods: {
    handleSetFontSize() {
      this.$emit('set-font-size');
    },
  },
});
